<template>
    <SwLayout>
        <div class="d-block" v-if="submission && submission.category_id">
            <div class="mb-4">
                <div class="form-group row">
                    <!-- <p class="px-4 mb-0">
                        {{ translate(  "Please browse the Agent links below to make sure you direct your Submission to the Agent most likely to be receptive to your work." ) }}
                    </p>
                    <p class="px-4">
                        {{ translate( "When you have made your selection, you can write a personal note to the Agent in question." ) }}
                    </p> -->
                    <div class="col-12 py-6 col-form-label">
                        <div class="radio-list dm-editor-list-wizard">
                            <SingleEditorCard
                                v-for="editor in matching_editors"
                                :key="'exclusive-editor-card-' + editor.id"
                                :editor="editor"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            {{ translate("To select an Agent you must first") }}
            <router-link
                :to="{ name: 'genres' }"
                class="text-warning text-hover-success"
            >
                {{ translate("go to the previous step") }}
            </router-link>
            {{ translate("and select a category.") }}
        </div>
    </SwLayout>
</template>

<script>
import { validationMixin } from "@/mixins/validationMixin.js";
import { swalLandingMixin } from "@/mixins/swalLandingMixin.js";
import SingleEditorCard from "./partials/SingleEditorCard.vue";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState, mapWritableState, mapActions } from "pinia";

export default {
    components: { SingleEditorCard },

    mixins: [swalLandingMixin, validationMixin],

    data() {
        return {
            setting_editor: false,
        };
    },
    computed: {
        ...mapState(useSubmissionWizardStore, ["matching_editors"]),
        ...mapWritableState(useSubmissionWizardStore, [
            "submission",
            "bottom_navigation_rules",
        ]),

        isValid() {
            return this.submission.editor_id > 0;
        },
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, [
            "loadMatchingEditors",
            "saveSubmission",
        ]),
    },
    mounted() {
        this.loadMatchingEditors();

        var self = this;
        setTimeout(function () {
            self.editor_id = self.submission.temp_selected_editor_id;
        }, 1000);
    },
};
</script>
